// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { getMilanoteApplicationModeSelector } from '../../../../platform/platformSelector';
import { MilanoteApplicationMode } from '../../../../../common/platform/platformTypes';

import './SettingsRow.scss';

const SettingsRow = (props) => {
    const {
        children,
        label,
        details,
        disabled,
        loading,
        disableLabelToggle,
        className,
        onlyInAppMode,
        showDetailsOnMobile = false,
    } = props;

    const appMode = useSelector(getMilanoteApplicationModeSelector);
    if (onlyInAppMode && appMode !== onlyInAppMode) return null;

    // If we don't want the entire label to toggle the button, then use a div instead of a label
    const WrapperElement = disableLabelToggle ? 'div' : 'label';

    const showDetails = details && (showDetailsOnMobile || appMode === MilanoteApplicationMode.desktop);

    return (
        <WrapperElement className={classNames('SettingsRow', className, { 'has-details': details, disabled, loading })}>
            <div className="label">{label}</div>
            {showDetails && <div className="details">{details}</div>}
            <div className="input">{children}</div>
        </WrapperElement>
    );
};

SettingsRow.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    details: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    disableLabelToggle: PropTypes.bool,
    onlyInAppMode: PropTypes.string,
    showDetailsOnMobile: PropTypes.bool,
};

export default SettingsRow;
